import { create } from 'zustand';

import { FeatureName } from '../feature-access';

interface CustomMessage {
  title: string;
  description: string;
}
interface LimitReachedDialogState {
  featureName: FeatureName | null;
  setFeatureName: (featureName: FeatureName) => void;
  onClose: () => void;
  open: boolean;
  customMessage: CustomMessage | null;
  setCustomMessage: (customMessage: CustomMessage | null) => void;
}

export const useUsageLimitStore = create<LimitReachedDialogState>((set) => ({
  featureName: null,
  open: false,
  setFeatureName: (featureName) =>
    set(() => ({
      featureName,
      open: true,
    })),
  customMessage: null,
  setCustomMessage: (customMessage) =>
    set(() => ({
      customMessage,
    })),
  onClose() {
    set(() => ({
      featureName: null,
      customMessage: null,
      open: false,
    }));
  },
}));
